import React from 'react'
import { string } from 'prop-types'
import SidebarImage from '../CategoryImages/Sidebar'
import { CategoryDiv } from '../styles/CategoryDiv'

const CategoryInner = ({ description }) => (
  <CategoryDiv>
    <SidebarImage category={description} />
    <p> {description} </p>
  </CategoryDiv>
)

CategoryInner.propTypes = {
  description: string.isRequired,
}

export default CategoryInner



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Categories/CategoryInner.jsx